export default "__VITE_ASSET__BkFjva59__"